module.exports = __webpack_public_path__ + "static/media/google.626c611c.svg";